export const TOGGLE_LOADING = 'additionalInformation/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'additionalInformation/TOGGLE_SUCCESS'
export const GET_ADDITIONAL_INFORMATION = 'additionalInformation/GET_ADDITIONAL_INFORMATION'
export const SET_ADDITIONAL_INFORMATION = 'additionalInformation/SET_ADDITIONAL_INFORMATION'
export const EDIT_ADDITIONAL_INFORMATION = 'additionalInformation/EDIT_ADDITIONAL_INFORMATION'
export const SET_PERMISSIONS = 'additionalInformation/SET_PERMISSIONS'
